import React from 'react'
import { Grid, Box, Typography, useTheme } from '@mui/material'
import { Settings as SettingsIcon } from '@mui/icons-material'
import { PageContainer } from '../components/ui/StyledComponents'
import ProfileSettings from '../components/ProfileSettings'

function SettingsPage() {
  const theme = useTheme()

  return (
    <PageContainer>
      <Box sx={{ mb: { xs: 3, sm: 4 } }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            mb: 2,
          }}
        >
          <Box
            sx={{
              width: { xs: 40, sm: 48 },
              height: { xs: 40, sm: 48 },
              borderRadius: 2,
              backgroundColor: theme.palette.mode === 'dark' 
                ? 'rgba(52, 152, 219, 0.2)' 
                : 'rgba(52, 152, 219, 0.1)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <SettingsIcon 
              sx={{ 
                fontSize: { xs: 24, sm: 28 }, 
                color: theme.palette.primary.main 
              }} 
            />
          </Box>
          <Box>
            <Typography 
              variant="h4" 
              sx={{
                fontSize: { xs: '1.5rem', sm: '2rem', md: '2.125rem' },
                fontWeight: 600,
                color: theme.palette.text.primary,
              }}
            >
              Settings
            </Typography>
            <Typography 
              variant="body2" 
              sx={{
                color: theme.palette.text.secondary,
                fontSize: { xs: '0.875rem', sm: '1rem' },
                mt: 0.5,
              }}
            >
              Manage your account settings and preferences
            </Typography>
          </Box>
        </Box>
      </Box>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <ProfileSettings />
        </Grid>
      </Grid>
    </PageContainer>
  )
}

export default SettingsPage

